import React, { useRef } from "react";

function LayoutImg(props) {
  const layoutImgRef = useRef();
  return (
    <img
      src={props.img}
      alt=""
      ref={layoutImgRef}
      onClick={props.onClick}
      onMouseOver={() => (layoutImgRef.current.src = props.hoverImg)}
      onMouseOut={() => (layoutImgRef.current.src = props.img)}
    />
  );
}

export default LayoutImg;
